import isMobile from "ismobilejs";

const firstAvailable = (...values) => values.find(value => !!value) || false;

export default {
  computed: {
    isMobileDevice() {
      return isMobile().any;
    }
  },
  methods: {
    resolveHeaderCover(content, config) {
      const source = content || {};
      const setup = config || {};

      if (this.isMobileDevice) {
        return firstAvailable(
          source.picture_mobile,
          source.cover_mobile,
          setup.cover_mobile,
          source.cover
        );
      }

      return firstAvailable(source.cover);
    },
    resolveHeaderPlaceholderCover(config) {
      const setup = config || {};

      if (this.isMobileDevice) {
        return firstAvailable(
          setup.placeholder_cover_mobile,
          setup.placeholder_cover
        );
      }

      return firstAvailable(setup.placeholder_cover);
    }
  }
};
